<template>
  <ValidationObserver ref="loadingsForm">
    <h6 v-if="someLoadingPermission()" class="mb-6">Carregamentos</h6>
    <div class="wrapper-loading">
      <div v-if="permissoes.Corretagem" class="item-loading items-baseline">
        <span>
          <label for="Corretagem">Corretagem</label>
        </span>

        <ValidationProvider
          name="Corretagem"
          :rules="{
            required: true,
            max_brokerage_discount: true,
            between: [10, valorMaximoCorretagem],
          }"
          v-slot="{ errors }"
        >
          <vs-input
            class="w-full"
            type="number"
            step="1"
            v-mask="['##']"
            icon-pack="feather"
            icon="icon-percent"
            v-model="carregamentos.Corretagem.porcentagem"
            @blur="recalcular()"
            id="Corretagem"
            :danger="!!errors.length"
            :disabled="isCanceled"
            data-testId="brokerage-percentage"
          />
          <div></div>
          <span
            v-show="!!errors.length"
            class="text-danger"
            data-testId="brokerage-percentage-error"
            >{{ errors[0] }}</span
          >
        </ValidationProvider>
      </div>
      <div
        v-if="enableDiscount && permissoes.Corretagem"
        class="item-loading items-baseline"
      >
        <span class="flex gap-2">
          <label for="Desconto">Desconto</label>
          <a style="cursor: pointer" @click="openModalAccountBalance()">
            <feather-icon
              icon="SearchIcon"
              svgClasses="h-6 w-6 p-1 text-white"
              class="align-middle bg-primary rounded-full"
          /></a>
        </span>
        <ValidationProvider
          name="Desconto"
          rules="required|max_value_discount|min_value_discount"
          v-slot="{ errors }"
        >
          <money
            name="Desconto"
            class="vs-inputx vs-input--input normal"
            id="Desconto"
            v-model="formData.desconto"
            @focus.native="beforeInsertDiscount"
            v-bind="money"
            :danger="!!errors.length"
            @blur.native="recalcular()"
            :disabled="isCanceled"
            data-testId="discount"
          ></money>
          <div></div>
          <span
            v-show="!!errors.length"
            class="text-danger"
            data-testId="discount-error"
            >{{ errors[0] }}</span
          >
        </ValidationProvider>

        <span v-if="nextMonthDiscountMessage" class="text-warning">
          {{ nextMonthDiscountMessage }}
        </span>
      </div>

      <div v-if="permissoes['Despesa ADM']" class="item-loading items-baseline">
        <span><label for="Despesa ADM">Taxa Administrativa</label></span>
        <ValidationProvider
          name="Despesa ADM"
          :rules="{
            required: true,
            between: [0, valorMaximoDespesaAdm],
          }"
          v-slot="{ errors }"
        >
          <vs-input
            class="w-full"
            type="number"
            step="1"
            v-mask="['##']"
            icon-pack="feather"
            icon="icon-percent"
            v-model="carregamentos['Despesa ADM'].porcentagem"
            @blur="recalcular()"
            id="Despesa ADM"
            :max="valorMaximoDespesaAdm"
            :danger="!!errors.length"
            :disabled="isCanceled"
            data-testId="adm-expenses-percentage"
          />
          <div></div>
          <span
            v-show="!!errors.length"
            class="text-danger"
            data-testId="adm-expenses-percentage-error"
            >{{ errors[0] }}</span
          >
        </ValidationProvider>
      </div>
      <div
        v-if="permissoes['Margem de Lucro']"
        class="item-loading items-baseline"
      >
        <span>
          <label for="Margem de Lucro">Margem de Lucro</label>
        </span>
        <ValidationProvider
          name="Margem de Lucro"
          :rules="{
            required: true,
            between: [0, valorMaximoMargemDeLucro],
          }"
          v-slot="{ errors }"
        >
          <vs-input
            class="w-full"
            type="number"
            step="1"
            v-mask="['##']"
            icon-pack="feather"
            icon="icon-percent"
            v-model="carregamentos['Margem de Lucro'].porcentagem"
            @blur="recalcular()"
            id="Margem de Lucro"
            :danger="!!errors.length"
            :disabled="isCanceled"
            data-testId="profit-margin-percentage"
          />
          <div></div>
          <span
            v-show="!!errors.length"
            class="text-danger"
            data-testId="profit-margin-percentage-error"
            >{{ errors[0] }}</span
          >
        </ValidationProvider>
      </div>
      <div v-if="permissoes.Estipulante" class="item-loading items-baseline">
        <span>
          <label for="Estipulante">Estipulante</label>
        </span>

        <ValidationProvider
          name="Estipulante"
          :rules="{
            required: true,
            between: [0, valorMaximoEstipulante],
          }"
          v-slot="{ errors }"
        >
          <vs-input
            class="w-full"
            type="number"
            step="1"
            v-mask="['##']"
            icon-pack="feather"
            icon="icon-percent"
            v-model="carregamentos.Estipulante.porcentagem"
            @blur="recalcular()"
            id="Estipulante"
            :danger="!!errors.length"
            :disabled="isCanceled"
            data-testId="stipulator-percentage"
          />
          <div></div>
          <span
            v-show="!!errors.length"
            class="text-danger"
            data-testId="stipulator-percentage-error"
            >{{ errors[0] }}</span
          ></ValidationProvider
        >
      </div>
    </div>

    <vs-row v-if="showTotal">
      <div vs-w="12" class="text-right mt-4">
        <h4>
          Total:
          <span>{{ somaCarregamentoTotal }}%</span>
        </h4>
      </div>
    </vs-row>
    <Modal
      class="holamundo"
      title="Saldo Da Conta Corrente"
      :active.sync="modalBrokerAccoutBalance"
      @close="modalBrokerAccoutBalance = false"
    >
      Saldo Atual: {{ brokerAccountBalance | currency }}
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            @click="modalBrokerAccoutBalance = false"
            type="gradient"
            color="warning"
            class="mt-5"
            data-testId="ok-button"
          >
            <feather-icon
              class="text-white"
              icon="CheckIcon"
              svgClasses="h-4 w-4"
            ></feather-icon>
            Ok
          </vs-button>
        </div>
      </div>
    </Modal>
  </ValidationObserver>
</template>
<script>
import { Money } from 'v-money';
import {
  ValidationObserver,
  ValidationProvider,
  Validator,
} from 'vee-validate';
import autoApi from '../../../../services/auto.api';
import { MAX_BROKERAGE } from '../../../../utils/constants';
import Modal from '../../../../components/Modal.vue';

export default {
  props: [
    'formData',
    'mostraTotal',
    'premio',
    'isCanceled',
    'enableDiscount',
    'brokerId',
    'nextMonthDiscountMessage',
    'brokerAccountBalanceInsufficient',
    'brokerAccountBalanceUsed',
  ],
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      carregamentos: {
        'Despesa ADM': { porcentagem: 0 },
        'Margem de Lucro': { porcentagem: 0 },
        Corretagem: { porcentagem: 0 },
        Estipulante: { porcentagem: 0 },
      },
      desconto: 0,
      configsDesconto: null,
      mostraTotalPadrao: false,
      modalBrokerAccoutBalance: false,
      brokerAccountBalance: null,
      isLoaded: false,
      maxDiscountAllowed: null,
      firstDiscountLoaded: null,
      MAX_BROKERAGE: MAX_BROKERAGE,
      maxCharges: 99.99,
    };
  },
  watch: {
    carregamentos: {
      handler: function () {
        this.validateForm();
      },
      deep: true,
    },
    async brokerId() {
      await this.getAccountBalance();
    },
    async brokerAccountBalanceInsufficient() {
      if (this.brokerId && this.isLoaded) {
        await this.getAccountBalance();
        this.maxDiscountAllowed =
          this.brokerAccountBalance + this.firstDiscountLoaded;
      }
    },
    async brokerAccountBalanceUsed() {
      if (this.brokerId && this.isLoaded) {
        await this.getAccountBalance();
        this.maxDiscountAllowed =
          this.brokerAccountBalance +
          this.getNumberDiscount(this.formData.desconto);
        this.firstDiscountLoaded = this.getNumberDiscount(
          this.formData.desconto,
        );
      }
    },
    brokerAccountBalance() {
      if (this.brokerAccountBalance !== null && !this.isLoaded) {
        this.maxDiscountAllowed =
          this.brokerAccountBalance +
          this.getNumberDiscount(this.formData.desconto);
      } else if (this.firstDiscountLoaded !== null && this.isLoaded) {
        this.maxDiscountAllowed =
          this.brokerAccountBalance + this.firstDiscountLoaded;
      }
    },
    maxDiscountAllowed() {
      this.validateForm();
    },
    formData: {
      handler() {
        if (this.brokerAccountBalance !== null && !this.isLoaded) {
          this.firstDiscountLoaded = this.getNumberDiscount(
            this.formData.desconto,
          );
          this.maxDiscountAllowed =
            this.brokerAccountBalance + this.firstDiscountLoaded;
        }
        this.validateForm();
      },
      deep: true,
    },
    premio() {
      this.validateForm();
    },
  },
  computed: {
    isLoadingsSumValid() {
      return this.somaCarregamentoTotal <= this.maxCharges;
    },
    valorMaximoDespesaAdm() {
      return this.roundToTwo(
        this.maxCharges -
          (Number(this.carregamentos['Margem de Lucro'].porcentagem) +
            Number(this.carregamentos.Corretagem.porcentagem) +
            Number(this.carregamentos.Estipulante.porcentagem)),
      );
    },
    valorMaximoMargemDeLucro() {
      return this.roundToTwo(
        this.maxCharges -
          (Number(this.carregamentos['Despesa ADM'].porcentagem) +
            Number(this.carregamentos.Corretagem.porcentagem) +
            Number(this.carregamentos.Estipulante.porcentagem)),
      );
    },
    valorMaximoCorretagem() {
      const maxPossible = this.roundToTwo(
        this.maxCharges -
          (Number(this.carregamentos['Despesa ADM'].porcentagem) +
            Number(this.carregamentos['Margem de Lucro'].porcentagem) +
            Number(this.carregamentos.Estipulante.porcentagem)),
      );

      return maxPossible > this.MAX_BROKERAGE
        ? this.MAX_BROKERAGE
        : maxPossible;
    },
    valorMaximoEstipulante() {
      return this.roundToTwo(
        this.maxCharges -
          (Number(this.carregamentos['Despesa ADM'].porcentagem) +
            Number(this.carregamentos['Margem de Lucro'].porcentagem) +
            Number(this.carregamentos.Corretagem.porcentagem)),
      );
    },
    somaCarregamentoTotal() {
      return (
        +this.carregamentos['Despesa ADM'].porcentagem +
        +this.carregamentos['Margem de Lucro'].porcentagem +
        +this.carregamentos.Corretagem.porcentagem +
        +this.carregamentos.Estipulante.porcentagem
      );
    },
    permissoes() {
      return {
        ['Despesa ADM']: this.$can(
          'Editar Carregamento - Despesa ADM',
          'Cotações',
        ),
        ['Margem de Lucro']: this.$can(
          'Editar Carregamento - Margem de Lucro',
          'Cotações',
        ),
        Corretagem: this.$can('Editar Carregamento - Corretagem', 'Cotações'),
        Estipulante: this.$can('Editar Carregamento - Estipulante', 'Cotações'),
      };
    },
    showTotal() {
      return this.mostraTotal || this.mostraTotalPadrao;
    },
  },
  created() {
    this.getBrokerAccountConfigs();
    Validator.extend('max_value_discount', {
      getMessage: (field) => {
        const maxDiscount = this.getMaxDiscountValue();
        return `O valor máximo de desconto é de R$ ${maxDiscount}`;
      },
      validate: (value) => {
        if (!value) return true;
        if (!this.configsDesconto || !this.isLoaded) return true;

        const descontoFormatado = this.getNumberDiscount(value);
        const maxDiscount = this.getMaxDiscountValue();

        return descontoFormatado <= maxDiscount;
      },
    });
    Validator.extend('min_value_discount', {
      getMessage: (field) => `O valor mínimo de desconto é de R$ 0,00`,
      validate: (value) => {
        if (!value) return true;

        const descontoFormatado = this.getNumberDiscount(value);
        return descontoFormatado >= 0;
      },
    });
    Validator.extend('max_brokerage_discount', {
      getMessage: (field) =>
        `O percentual máximo de corretagem permitido quando há desconto é de ${this.configsDesconto.max_brokerage_percentage}%`,
      validate: (value) => {
        if (!value) return true;
        if (!this.configsDesconto) return true;
        const descontoFormatado = this.getNumberDiscount(
          this.formData.desconto,
        );
        if (descontoFormatado === 0) return true;

        return Number(value) <= this.configsDesconto.max_brokerage_percentage;
      },
    });
  },
  mounted() {
    this.atribuirCarregamentos();
    if (this.brokerId) {
      this.getAccountBalance();
    }
    this.validateForm();
  },
  methods: {
    validateForm() {
      this.$nextTick(() => {
        this.$refs.loadingsForm.validate();
      });
    },
    getMaxDiscountValue() {
      return parseFloat(
        Math.min(
          this.configsDesconto.max_discount_value,
          this.maxDiscountAllowed,
          (this.premio / 100) * this.configsDesconto.max_discount_percentage,
        ).toFixed(2),
      );
    },
    beforeInsertDiscount() {
      if (!this.isLoaded) {
        this.isLoaded = true;
      }
    },
    notifyAccountBalanceError() {
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'Não foi possível buscar o saldo',
        color: 'danger',
      });
    },
    someLoadingPermission() {
      return (
        this.$can('Editar Carregamento - Despesa ADM', 'Cotações') ||
        this.$can('Editar Carregamento - Margem de Lucro', 'Cotações') ||
        this.$can('Editar Carregamento - Corretagem', 'Cotações') ||
        this.$can('Editar Carregamento - Estipulante', 'Cotações')
      );
    },
    getNumberDiscount(value) {
      if (!value) return 0;
      return typeof value != 'number'
        ? Number(value.replace('R$ ', '').replace('.', '').replace(',', '.'))
        : value;
    },
    openModalAccountBalance() {
      this.modalBrokerAccoutBalance = true;
      this.getAccountBalance();
    },
    roundToTwo(num) {
      return Math.round(num * 100) / 100;
    },
    recalcular() {
      this.$refs.loadingsForm.validate().then((isValid) => {
        if (isValid && this.isLoadingsSumValid) {
          this.$emit('recalcular');
        }
      });
    },
    atribuirCarregamentos() {
      if (!this.formData.carregamentos) {
        console.error('ERRO NO CONTRATO DO OBJETO - CARREGAMENTOS');
        return;
      }

      this.$set(this, 'carregamentos', this.formData.carregamentos);
    },
    somarPorcentagemCarregamentos(carregamentos) {
      return Object.values(carregamentos).reduce((acc, curr) => {
        return (acc += +curr.porcentagem);
      }, 0);
    },
    getBrokerAccountConfigs() {
      autoApi
        .getBrokerAccountConfigs()
        .then((res) => {
          this.configsDesconto = res;
        })
        .catch((error) => {
          console.error(error);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi buscar as configurações da conta corrente',
            color: 'danger',
          });
        });
    },
    async getAccountBalance() {
      try {
        this.$vs.loading();
        const res = await autoApi.getBalance(this.brokerId);
        this.brokerAccountBalance = res.balance;
      } catch (error) {
        this.notifyAccountBalanceError();
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  components: {
    Money,
    Modal,
    ValidationProvider,
    ValidationObserver,
  },
};
</script>
<style>
.text-danger {
  font-size: 12px;
}

.wrapper-loading {
  display: grid;
  grid-gap: 15px 50px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

@media (min-width: 1440px) {
  .wrapper-loading {
    display: grid;
    grid-gap: 15px 50px;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}
@media (min-width: 1822px) {
  .wrapper-loading {
    display: grid;
    grid-gap: 15px 100px;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
}

.item-loading {
  position: relative;
  display: grid;
  grid-gap: 0.2rem;
  grid-template-columns: 2fr minmax(100px, 2fr);
}

.item-loading::after {
  content: '';
  position: absolute;
  background-color: #eee;
}

.item-loading::after {
  width: 100%;
  height: 1px;
  bottom: -6px;
}
</style>
